<template>
  <div class="wrap">
    <div class="mar_task">
      <div>
        <span>营销任务:</span>
        <el-cascader size="medium" :props="{ label: 'taskName', value: 'id', children: 'taskList' }" :options="targetList" :show-all-levels="false" @change="handleChange" v-model="selectValue"></el-cascader>
        <el-button class="btn" size="medium" @click="handleDraw">查看详情</el-button>
      </div>
      <!--更新时间展示-->
      <div v-if="Object.keys(selectObj).length > 0">
        <span v-if="selectObj.status === 4">数据更新至{{selectObj.startTimeFormat}} ~ {{moment().subtract(1, 'days').format('YYYY-MM-DD')}}</span>
        <span v-else>数据更新至{{selectObj.startTimeFormat}} ~ {{selectObj.endTimeFormat}}</span>
      </div>
      <div v-else>
        <span v-if="defaultTask.status === 4">数据更新至{{defaultTask.startTimeFormat}} ~ {{moment().subtract(1, 'days').format('YYYY-MM-DD')}}</span>
        <span v-else>数据更新至{{defaultTask.startTimeFormat}} ~ {{defaultTask.endTimeFormat}}</span>
      </div>
    </div>
    <div class="mar_data">
      <div class="title">数据概览</div>
      <div class="data_item">
        <userCover :userCover="userCover" :taskChildData="Object.keys(selectObj).length > 0 ? selectObj : defaultTask"/>
        <couponCostCom :couponCostData="couponCostData" :taskChildData="Object.keys(selectObj).length > 0 ? selectObj : defaultTask"/>
        <targetPeople :userOrderData="userOrderData" :taskChildData="Object.keys(selectObj).length > 0 ? selectObj : defaultTask"/>
      </div>
    </div>
    <div class="mar_target">
      <div class="title">任务数据日趋势</div>
      <taskData :isChangeTask="selectValue" :taskDayDataSum="taskDayDataSum" :taskDayData="taskDayData" :taskChildData="Object.keys(selectObj).length > 0 ? selectObj : defaultTask"/>
    </div>
    <div class="mar_target">
      <div class="title">目标用户群营销效果对比分析</div>
      <targetUser :isChangeTask="selectValue" :targetUser="targetUser" :taskChildData="Object.keys(selectObj).length > 0 ? selectObj : defaultTask"/>
    </div>
    <el-drawer
      title="活动详情"
      :with-header="false"
      :visible.sync="drawer"
      size="35%"
      direction="rtl">
      <div class="draw-content">
        <div class="draw-fa">
          <div class="draw-title"><img @click="drawer = false" src="https://web.nlktj.com/ty/merchant/persisMarket/draw-close.png" alt=""><span>活动详情</span></div>
          <div class="draw">
            <div><span>活动名称：</span><div>{{detailForm.taskName}}</div></div>
            <div><span>创建时间：</span><div>{{detailForm.createTime}}</div></div>
            <div><span>任务状态：</span><div>{{detailForm.statusName}}</div></div>
            <div><span>油站名称：</span><div>{{detailForm.gasName}}</div></div>
            <div><span>发券目的：</span><div>{{detailForm.targetName}}</div></div>
            <div v-if="[4,5].includes(detailForm.status)"><span>发券画像：</span><div>{{detailForm.portrayalName}}（创建时{{detailForm.totalUserNum}}人 <span v-if="detailForm.totalRealUserNum">发券时{{detailForm.totalRealUserNum}}人</span>）</div></div>
            <div v-if="[3,6].includes(detailForm.status)"><span>发券画像：</span><div>{{detailForm.portrayalName}}（{{detailForm.setUserNum}}人）</div></div>
            <div v-if="[4,5].includes(detailForm.status)"><span>发券时间：</span><div>计划时间 {{detailForm.setStartTime}}<span v-if="detailForm.startTime"> 实际时间 {{detailForm.startTime}}</span></div></div>
            <div v-if="[3,6].includes(detailForm.status)"><span>发券时间：</span><div>定时发放 {{detailForm.setStartTime}}</div></div>
            <div v-if="[4,5].includes(detailForm.status)"><span>发券人数：</span><div>计划发放{{detailForm.setUserNum}}人 <span v-if="detailForm.realUserNum">实际发放{{detailForm.realUserNum}}人</span></div></div>
            <div v-if="[3,6].includes(detailForm.status)"><span>发券人数：</span><div>计划发放{{detailForm.setUserNum}}人</div></div>
            <div v-if="detailForm.couponExpireTime"><span>券到期时间：</span><div>{{detailForm.couponExpireTime}}</div></div>
            <div>
              <span>发放券包：</span>
              <div class="coupon">
                <coupon v-for="(item, index) in detailForm.couponList" :key="index" :item="item"/>
              </div>
            </div>
            <div class="money">
              <span></span><div>包含<span style="color: #3377FF">{{allCoupon}}</span>张优惠券，共<span style="color: #3377FF">{{allMoney}}</span>元</div>
            </div>
            <div><span>发券费用：</span><div>预估发券成本{{allBudget}}元 <span v-if="detailForm.realUserNum"> 实际最大发券成本{{allRealBudget}}元 <span class="word_fa">（您发的券被用户核销使用时，才会产生实际营销成本）</span></span></div></div>
            <div>
              <span>通知方式：</span>
              <div>
                <span>{{detailForm.noticeWayName}}</span>
                <div class="mess" v-if="detailForm.smsContent">
                  <p class="push">短信推送</p>
                  <p class="push-con g-flex-c">
                    <span>{{detailForm.smsContent}}</span>
                  </p>
                </div>
                <div class="mess" v-if="detailForm.pushContent">
                  <p class="push"><img src="../../../assets/image/logo.png" alt=""><span>APP推送</span></p>
                  <p class="push-con g-flex-c">
                    <span>
                      <span style="display: block; margin-bottom: 3px">{{detailForm.pushTitle}}</span>
                      <span>{{detailForm.pushContent}}</span>
                    </span>
                  </p>
                </div>
              </div>
            </div>
            <div v-if="detailForm.approvalUserName"><span>审核人：</span><div>{{detailForm.approvalUserName}}</div></div>
          </div>
        </div>
        <div class="bo-btn">
          <div class="btn-wrap">
            <span  @click.stop="cancalTask(detailForm.taskId)" v-if="[3].includes(detailForm.status)" class="effect">取消任务</span>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import { taskDetail } from '@/api/vipMarket'
import { mapGetters } from 'vuex'
import { taskList, couponCost, userOrder, userStatistics, effectData, taskDayDataSum, taskDayData } from '@/api/vipMarket/userData'
import userCover from './components/userCover'
import couponCostCom from './components/couponCost'
import targetPeople from './components/targetPeople'
import taskData from './components/taskData'
import targetUser from './components/targetUser'
import coupon from '../../marketPromotion/myProComponents/CouponItem'
import moment from 'moment'
export default {
  data () {
    return {
      drawer: false, // 抽屉
      detailForm: {},
      selectValue: [], // 选中的枚举
      targetList:[], // 枚举值
      selectObj: {}, // 选中的枚举值子值对象
      defaultTask: {}, // 一进页面默认选中的枚举值子值对象
      couponCostData: {}, // 券营销成本数据（饼图）
      userOrderData: {}, // 目标人群画像（饼状图）
      userCover: {}, // 用户转换情况（梯形）
      targetUser: {}, // 目标用户群营销效果对比分析（柱状）
      taskDayDataSum: {}, // 任务数据趋势非图数据（折线）
      taskDayData: {}, // 任务数据趋势折线图（折线
      target: '', // 路由携带回来的
      taskId: '' // 路由携带回来的
    }
  },
  computed: {
    allCoupon () {
      // 计算优惠券张数
      const { couponList = [] } = this.detailForm
      return couponList.reduce((sum, next) => sum + next.number, 0)
    },
    // 发券预算成本
    allMoney () {
      const { couponList = [] } = this.detailForm
      return couponList.reduce((sum, next) => sum + (next.amount * next.number), 0)
    },
    // 发券预算成本
    allBudget () {
      const { couponList = [], setUserNum } = this.detailForm
      return couponList.reduce((sum, next) => sum + (next.amount * next.number), 0) * setUserNum
    },
    // 发券实际成本
    allRealBudget () {
      const { couponList = [], realUserNum = 0 } = this.detailForm
      return couponList.reduce((sum, next) => sum + (next.amount * next.number), 0) * realUserNum
    },
    ...mapGetters(['userInfo'])
  },
  components: {
    userCover,
    couponCostCom,
    targetPeople,
    taskData,
    targetUser,
    coupon
  },
  mounted () {
    this.$track.pageViewEvent('用户营销-营销数据', '1638794970')
    const { target, taskId } = this.$route.query
    this.target = target
    this.taskId = taskId
    this.taskListApi({ gasId: this.userInfo.gasId })
  },
  methods: {
    moment,
    handleChange (val) {
      this.targetList.map(item => {
        if (item.id === val[0]) {
          this.selectObjList = item.taskList
        }
      })
      this.selectObjList.map(item => {
        if (item.id === val[1]) {
          this.selectObj = item
        }
      })
      const paramsApi = { gasId: this.userInfo.gasId, taskId: this.selectObj.id }
      this.userStatisticsApi(paramsApi)
      this.couponCostApi(paramsApi)
      this.userOrderApi(paramsApi)
      this.taskDayDataSumApi(paramsApi)
      this.taskDayDataApi({ ...paramsApi, startDate: this.selectObj.startTimeFormat, endDate: this.selectObj.endTimeFormat })
      this.effectDataApi(paramsApi)
    },
    handleDraw () {
      if (this.selectValue.length === 0) return this.$message.info('请先选择营销任务')
      this.drawer = true
      this.taskDetailApi({ taskId: this.selectValue[1] })
    },
    // 枚举接口
    async taskListApi (params) {
      try {
        const { code, result } = await taskList(params)
        if (code !== 200) return
        result.targetList.forEach(item => {
          item.id = item.target
          item.taskName = item.targetName
        })
        this.targetList = result.targetList // 处理枚举
        // 如果路由携带参数，不用默认值。配置到路由参数的对象值
        if (this.target || this.taskId) {
          this.targetList.map(item => {
            if (item.id === this.target) {
              this.selectObjList = item.taskList
            }
          })
          this.selectObjList.map(item => {
            if (item.id === this.taskId) {
              this.defaultTask = item
            }
          })
        } else {
          this.defaultTask = result.defaultTask // 默认值集合
        }
        this.selectValue = [this.defaultTask.target, this.defaultTask.id] // 默认赋值
        const paramsApi = { gasId: this.userInfo.gasId, taskId: this.defaultTask.id }
        this.userStatisticsApi(paramsApi)
        this.couponCostApi(paramsApi)
        this.userOrderApi(paramsApi)
        this.taskDayDataSumApi(paramsApi)
        this.taskDayDataApi({ ...paramsApi, startDate: this.defaultTask.startTimeFormat, endDate: this.defaultTask.endTimeFormat })
        this.effectDataApi(paramsApi)
      } catch (error) {
        console.log(error)
      }
    },
    // 券营销成本
    async couponCostApi (params) {
      try {
        const { code, result } = await couponCost(params)
        if (code !== 200) return
        this.couponCostData = result || {}
      } catch (error) {
        console.log(error)
      }
    },
    // 目标画像人群饼状图
    async userOrderApi (params) {
      try {
        const { code, result } = await userOrder(params)
        if (code !== 200) return
        this.userOrderData = result || {}
      } catch (error) {
        console.log(error)
      }
    },
    // 用户转化情况
    async userStatisticsApi (params) {
      try {
        const { code, result } = await userStatistics(params)
        if (code !== 200) return
        this.userCover = result || {}
      } catch (error) {
        console.log(error)
      }
    },
    // 任务数据非图接口
    async taskDayDataSumApi (params) {
      try {
        const { code, result } = await taskDayDataSum(params)
        if (code !== 200) return
        this.taskDayDataSum = result || {}
      } catch (error) {
        console.log(error)
      }
    },
    // 任务数据（折线图）
    async taskDayDataApi (params) {
      try {
        const { code, result } = await taskDayData(params)
        if (code !== 200) return
        this.taskDayData = result || {}
      } catch (error) {
        console.log(error)
      }
    },
    // 目标用户群营销效果对比分析 (柱状图)
    async effectDataApi (params) {
      try {
        const { code, result } = await effectData(params)
        if (code !== 200) return
        this.targetUser = result || {}
      } catch (error) {
        console.log(error)
      }
    },
    // 详情接口(右侧抽屉)
    async taskDetailApi (params) {
      try {
        const { code, result } = await taskDetail(params)
        if (code !== 200) return
        this.detailForm = Object.assign({}, result)
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>
<style scoped lang="less">
.wrap{
  width: 100%;
  min-width: 1275px;
  padding: 30px 20px 30px 20px;
  // 营销任务
  .mar_task{
    width: 100%;
    height: 72px;
    padding: 20px;
    background: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    >div{
      height: 72px;
    }
    >div:nth-child(1) {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      >span{
        margin-right: 20px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #222222;
      }
      .btn{
        margin-left: 20px;
      }
    }
    >div:nth-child(2){
      text-align: right;
      line-height: 72px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
    }
  }
  // 数据概览
  .mar_data{
    width: 100%;
    margin-top: 10px;
    background: #fff;
    .data_item{
      display: flex;
      justify-content: space-around;
      align-items: center;
      padding: 0 0 20px 0;
      >div{
        width: 30%;
        min-width: 403px;
        height: 492px;
        border-radius: 4px;
        border: 1px solid #EBEEF5;
      }
    }
  }
  // 目标用户群营销效果对比分析
  .mar_target{
    width: 100%;
    margin-top: 30px;
    background: #fff;
  }
}
.title{
  padding: 16px 0 16px 20px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
}
.draw-content{
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.draw-fa{
  .draw-title{
    padding: 24px 0 20px 20px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    >img{
      display: block;
      width: 16px;
      height: 16px;
      cursor: pointer;
    }
    >span{
      margin-left: 10px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #222222;
    }
  }
  .draw{
    overflow-y: scroll;
    height: 640px;//纵向需要滚动条的话
    padding: 10px 30px 20px 20px;
    border-top: 1px solid #F4F4F4;
    >div{
      margin-top: 30px;
      display: flex;
      justify-content: flex-start;
      >span{
        width: 90px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
      }
      >div{
        flex:1;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #222222;
      }
    }
    >div:nth-child(1){
      margin-top: 10px;
    }
    .money{
      margin-top: 10px;
    }
    .mess{
      width: 305px;
      height: 156px;
      margin-top: 10px;
      border-radius: 2px;
      border: 1px solid #EBEEF5;
      .push{
        padding-left: 20px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        >img{
          display: inline-block;
          width: 14px;
          height: 14px;
        }
        >span{
          margin-left: 4px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
        }
      }
      .push-con{
        width: 304px;
        height: 110px;
        background: #FAFAFA;
        border: 1px solid #EBEEF5;
        border-bottom: none;
        >span{
          width: 253px;
          height: 68px;
          padding: 10px;
          background: #FFFFFF;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #1E1E28;
        }
      }
    }
  }
}
.bo-btn{
  width: 100%;
  height: 80px;
  background: #FFFFFF;
  box-shadow: 0px -2px 8px 0px #F4F7FC;
  .btn-wrap{
    width: 100%;
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    .effect{
      display: block;
      width: 120px;
      height: 40px;
      // margin: 20px 0 0 200px;
      text-align: center;
      line-height: 40px;
      background: #FFFFFF;
      border-radius: 4px;
      border: 1px solid #CCCCCC;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      cursor: pointer;
    }
  }
}
</style>